import { render, staticRenderFns } from "./SankeyChart.vue?vue&type=template&id=4b39f933&scoped=true"
import script from "./SankeyChart.vue?vue&type=script&lang=js"
export * from "./SankeyChart.vue?vue&type=script&lang=js"
import style0 from "./SankeyChart.vue?vue&type=style&index=0&id=4b39f933&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b39f933",
  null
  
)

export default component.exports